module.exports = __webpack_public_path__ + "img/conveniencias-02.3c985bec.png";